/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Disabled_Websites_Already_Disabled_Session_MessageInputs */

const en_disabled_websites_already_disabled_session_message = /** @type {(inputs: Disabled_Websites_Already_Disabled_Session_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.scope === "domain") return /** @type {LocalizedString} */ (`This domain is already disabled for the current session`);
	return /** @type {LocalizedString} */ (`This page is already disabled for the current session`)
	
};

const es_disabled_websites_already_disabled_session_message = /** @type {(inputs: Disabled_Websites_Already_Disabled_Session_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.scope === "domain") return /** @type {LocalizedString} */ (`Este dominio ya está deshabilitado para la sesión actual`);
	return /** @type {LocalizedString} */ (`Esta página ya está deshabilitada para la sesión actual`)
	
};

/**
* | scope | output |
* | --- | --- |
* | "domain" | "This domain is already disabled for the current session" |
* | * | "This page is already disabled for the current session" |
*
* @param {Disabled_Websites_Already_Disabled_Session_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_disabled_session_message = /** @type {((inputs: Disabled_Websites_Already_Disabled_Session_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Disabled_Session_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_disabled_session_message(inputs)
	return en_disabled_websites_already_disabled_session_message(inputs)
});